/* lua.js generated code undefined */
 // 4周（28天）付费标签配置（单位"分"）
let config = table(
    [1, 0, table([1, "min", 0], [1, "max", 0])],
    [1, 1, table([1, "min", 100], [1, "max", 600])],
    [1, 2, table([1, "min", 700], [1, "max", 3000])],
    [1, 3, table([1, "min", 3100], [1, "max", 16000])],
    [1, 4, table([1, "min", 16100], [1, "max", 160000])],
    [1, 5, table([1, "min", 160100], [1, "max", 9999999900])]
)
module.exports = config
